import axios from "axios";
import { toast } from "react-toastify";
import { store } from '../store';
import { setAuthorizationStatus } from "../store/main/action";
import i18n from "./i18n";


axios.interceptors.request.use(function (config) {
    const lng = localStorage.getItem('lang');
    if (lng && config.url.indexOf('lang') === -1){
        if (config.url.indexOf('?') === -1){
            config.url = config.url + `?lang=${lng}`
        } else {
            config.url = config.url + `&lang=${lng}`
        }
    }
    return config;
}, function (error) {

    return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {

    return response;
}, function (error) {
    const status = error?.response?.status;

    if (status && status >= 500) {
        toast.error(i18n.t("Что то пошло не так! Попробуйте позже."));
    }

    if (status === 401 || status === 429){
        store.dispatch(setAuthorizationStatus(false));
        localStorage.removeItem('b-token');
    }

    return Promise.reject(error);
});


export default axios;